import TagTitleView from './TagTitle.view';
export default TagTitleView;
